import MetadataDrivenCommon from './common/MetadataDrivenCommon';

class MetadataDrivenContainer extends MetadataDrivenCommon {
    constructor(viewModel, presentationModel, contentPath) {
        super(viewModel, presentationModel, contentPath, 'container');
        this.parseContent(this.presentationModel.content);
    }
}
export default MetadataDrivenContainer;